import { render, staticRenderFns } from "./AspectTablePrevButton.vue?vue&type=template&id=46585fb5&scoped=true&"
import script from "./AspectTablePrevButton.vue?vue&type=script&lang=js&"
export * from "./AspectTablePrevButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46585fb5",
  null
  
)

export default component.exports